import { render } from "./PageLayout.vue?vue&type=template&id=1f1857d4&scoped=true"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"

import "./PageLayout.vue?vue&type=style&index=0&id=1f1857d4&scoped=true&lang=css"

import exportComponent from "/Users/min/Desktop/lambda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1857d4"]])

export default __exports__